<template>
    <v-container
        class="scroll-updater-main-container"
        >
        <v-card class="mx-auto">
            <v-list-item two-line
                         v-scroll="scrollTopOverDetect"
                         >
                <v-list-item-content>
                    <v-col cols="11">
                        <v-list-item-title class="text-h5">
                            {{ this.title }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            {{ this.tag }} ({{ this.valueUpdatedAt }})
                        </v-list-item-subtitle>
                    </v-col>
                    <v-col cols="1">
                        <v-icon
                            class="keyframe-show-hide-all"
                            v-if="this.inAlarm"
                            color="pink"
                            style="width: 10px"
                            >mdi-bell-alert
                        </v-icon>
                    </v-col>
                </v-list-item-content>
            </v-list-item>
            <v-card-text>
                <v-row align="center">
                    <v-col class="text-h4" cols="6">
                        {{ this.value }}
                        {{ this.um }}
                    </v-col>
                    <v-col cols="6">
                        <!--
                        <v-img
                            v-if="this.image != ''"
                            :src="this.image"
                            alt="this.title"
                            width="92"
                            ></v-img>
                        -->
                        <UiImageCond
                            v-if="value != ''"
                            :uiId="parseInt(this.id)"
                            :value="''+this.value"
                            :size="92"
                            />
                    </v-col>
                </v-row>
            </v-card-text>
            <!-- membros do grupo -->
            <v-list-item
                v-for="uiMember in uisGroup"
                :key="uiMember.tag"
                class="sublist"
                >
                <v-col cols="2">
                    <v-img
                        v-if="uiMember.image != ''"
                        :src="uiMember.image"
                        :alt="uiMember.title"
                        class="image"
                        width="28"
                        ></v-img>
                </v-col>
                <v-col cols="10">
                    <v-list-item-subtitle>
                        <strong> {{ uiMember.title }}:</strong>
                        {{ uiMember.value }}
                        {{ uiMember.um }}
                    </v-list-item-subtitle>
                </v-col>
            </v-list-item>
        </v-card>
        <Spacer1/>
        <v-card class="mx-auto"
                >
            <PoiRegHistReportByDay
                v-if="tag"
                :tags="tag"
                />
        </v-card>
        <Spacer1/>
        <v-card class="mx-auto"
                >
            <PoiRegHistReportByHour
                v-if="tag"
                :tags="tag"
                />
        </v-card>
    </v-container>
</template>

<script>
    import axios from "axios";
    import { EventBus } from "@/event-bus";
    import moment from "moment";
    import { functions } from "../functions";
    import { scrollUpdater } from "../mixins/scrollUpdater";
    import PoiRegHistReportByDay from "./PoiRegHistReportByDay";
    import PoiRegHistReportByHour from "./PoiRegHistReportByHour";
    import Spacer1 from "./Spacer1";
    import { appCaller } from "../mixins/appCaller";
    import UiImageCond from "./UiImageCond";

    export default {
        name: "Ui",

        props: {},

        mixins: [scrollUpdater, appCaller],

        components: {
            PoiRegHistReportByDay,
            PoiRegHistReportByHour,
            Spacer1,
            UiImageCond
        },

        data: function () {
            return {
                items: [],
                id: this.$route.params.id,
                title: "",
                tag: "",
                value: "",
                valueUpdatedAt: "",
                um: "",
                uisGroup: [],
                image: "",
                //filesUrl: process.env.VUE_APP_FILES_URL,
                filesUrl: "",
                rootApi: process.env.VUE_APP_ROOT_API,
                inAlarm: ""
            };
        },

        created: function () {
            EventBus.$emit("eventPageLoad", {
                name: "Unidade de informação"
            });
        },

        mounted: function () {
            //Ação do usuário que dispara evento de atualização.
            EventBus.$on("scrollTopOverDetect", function () {
                this.appCallerDispatchEventByLevel(this.$updNowLevels.level1);
            }.bind(this));

            //Atualiza informações da tela quando evento for disparado.
            this.appCallerListenEventByLevel(this.$updNowLevels.level1, function () {
                this.loop();
            }.bind(this));
        },

        afterCreate: function () {},

        beforeCreate: function () {},

        beforeDestroy: function () {

        },

        methods: {
            touchHandler: function () {

            },

            loop: async function () {
                this.loadUi();
            },

            loadFromDb: async function (url) {
                const response = await axios.get(url, axios.getHeaders()).catch((err) => {
                    return functions.parseCatch(err, this.$appMessages.err404);
                });
                return response.data;
            },

            loadUi: async function () {
                EventBus.$emit("eventWaitingStart", {opacity: 0});
                const ui = await this.loadFromDb(this.rootApi + "/ui/get/" + this.id);
                this.title = ui.title;
                this.tag = ui.tag;
                this.value = ui.value;
                this.valueUpdatedAt = this.parseDateTime(ui.valueUpdatedAt);
                this.um = ui.um;
                this.inAlarm = ui.inAlarm;
                this.image = "";
                this.loadUiListGroup();
                EventBus.$emit("eventWaitingEnd");
            },

            uisGroupGetElemById: function (id) {
                for (let i in this.uisGroup) {
                    const elem = this.uisGroup[i];
                    if (elem.id == id) {
                        return elem;
                    }
                }
                return false;
            },

            loadUiListGroup: async function () {

                if (!this.tag) {
                    return;
                }

                const uisGroup = await this.loadFromDb(
                        this.rootApi + "/ui/listByGroup/" + this.tag
                        );

                uisGroup.map((elem) => {
                    if (elem.tag == this.tag) {
                        return;
                    }

                    let elemOld = this.uisGroupGetElemById(elem.id);
                    if (!elemOld) {
                        return this.uisGroup.push(elem);
                    }
                    elemOld.value = elem.value;
                });

                this.updateListIcons();
            },

            parseDateTime: function (dateTimeUs) {
                return moment(dateTimeUs).format("DD-MM-Y HH:mm:ss");
            },

            makeValue: function (elem) {
                return `${elem.value} (${elem.tag})`;
            },

            makeItem: function (elem) {
                return {
                    icon: true,
                    id: elem.id,
                    title: elem.title,
                    tag: "TAG" + elem.tag,
                    value: this.makeValue(elem),
                    inAlarm: elem.inAlarm,
                    image: "",
                    avatar: ""
                };
            },

            getImageCond: async function (uiId, value, fn) {

                if (!uiId || (value + "").trim() == "") {
                    return;
                }

                const url = this.rootApi + "/uicondexec/" + uiId + "/" + value;
                const conds = await this.loadFromDb(url);

                for (let i in conds) {
                    const cond = conds[i];
                    if (0 === parseInt(cond.isTrue) || cond.image == "") {
                        continue;
                    }
                    const image = cond.image;
                    fn(image);
                }

                return "";
            },

            updateListIcons: function () {
                for (let i in this.uisGroup) {
                    const elem = this.uisGroup[i];
                    this.getImageCond(
                            elem.id,
                            elem.value,
                            function (image) {
                                if (!image) {
                                    return;
                                }
                                elem.image = image;
                            }.bind(this)
                            );
                }
            },
        },
    };
</script>

<style scoped>
    .list-item-value {
        color: #999999;
        font-size: 12px;
    }

    .v-list-item__title {
        color: #666666;
        font-size: 13px;
    }

    .sublist.v-list-item .image {
        margin-right: 5px;
    }
</style>
